// extracted by mini-css-extract-plugin
export default {"DelayNavigatePage":"DelayNavigatePage_DelayNavigatePage__c47GW","Img":"DelayNavigatePage_Img__xz-Lj","Title":"DelayNavigatePage_Title__l3vo0","Text":"DelayNavigatePage_Text__QrzTL"};